import { BACKGROUND_BLUE, SLATE } from 'styles/Colors';
import { MediumDesktop, SmallMobile } from 'styles/MediaQueries';
import { useNavigate } from 'react-router-dom';
import CtaButton from '@opploans/cta-button-component/CtaButton';
import List from 'components/display/List';
import OppMobileScreen from 'images/OpploansMobileScreen.png';
import React, { useState } from 'react';

const headerStyle = {
  color: BACKGROUND_BLUE,
  fontSize: '1.5rem',
  textAlign: 'center',

  [MediumDesktop]: {
    fontSize: '2.875rem',
    textAlign: 'left'
  }
};

const listStyle = {
  fontSize: '1rem',
  textAlign: 'left',
  margin: '1rem 5% 1rem 5%',
  paddingLeft: '1em',

  [MediumDesktop]: {
    fontSize: '1rem',
    margin: '1rem 0 1rem 0'
  }
};

const listItemImageStyle = {
  height: '9px',
  paddingRight: '0.56rem',
  width: '9px'
};

const buttonStyle = {
  fontSize: '1rem',
  fontWeight: 'bold',
  padding: '1.375rem',

  [MediumDesktop]: {
    fontSize: '1.25rem',
    width: '23rem'
  }
};

const phoneImageStyle = {
  height: '15.75rem',
  padding: '1.5rem 0 1.875rem',
  width: '15.75rem',

  [MediumDesktop]: {
    height: '23.4375rem',
    padding: '0',
    width: '23.4375rem'
  }
};

const topSectionStyles = {
  fontWeight: 'bold',
  fontFamily: 'Arimo',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',

  [MediumDesktop]: {
    width: '100%',
    maxWidth: '75rem',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0 auto 5rem'
  }
};

const callToActionSectionStyle = {
  alignSelf: 'center',
  flexDirection: 'column',
  display: 'flex',
  paddingLeft: '3.5rem',
  paddingRight: '3.5rem',

  [SmallMobile]: {
    paddingLeft: '1rem',
    paddingRight: '1rem'
  },

  [MediumDesktop]: {
    alignSelf: 'end',
    paddingBottom: '1rem',
    paddingLeft: '1rem'
  }
};

const listItemAdditionalStyle = {
  listStyleImage: `url('/assets/BlueBulletPoint.svg')`,
  paddingLeft: '0.526rem',
  paddingBottom: '0.75rem',
  color: SLATE
};

function HeaderText({ partnerName, showCobranding }) {
  if (showCobranding) {
    return (
      <>
        <h1 css={headerStyle}>{partnerName} Recommends</h1>
        <h1 css={headerStyle}>OppLoans for Your</h1>
        <h1 css={headerStyle}>Financial Needs</h1>
      </>
    );
  }
  return (
    <>
      <h1 css={headerStyle}>OppLoans may be a Great</h1>
      <h1 css={headerStyle}>Fit for Your Financial Needs!</h1>
    </>
  );
}

const ListItemTwo = () => (
  <>
    Applying does NOT affect your FICO<sup>®</sup> credit score!²
  </>
);

function ClickThroughTopSection({ partnerName, showCobranding }) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setLoading(true);
    navigate('/register/lead_gate');
  };

  return (
    <div css={topSectionStyles}>
      <div css={callToActionSectionStyle}>
        <HeaderText partnerName={partnerName} showCobranding={showCobranding} />

        <div>
          <List
            listItems={[
              'Same-Day Funding Available¹',
              <ListItemTwo />,
              'Loans from $500 to $5,000.⁴'
            ]}
            listItemImageStyle={listItemImageStyle}
            listItemAdditionalStyle={listItemAdditionalStyle}
            listStyle={listStyle}
          />
        </div>

        <CtaButton
          additionalStyle={buttonStyle}
          onClick={handleClick}
          disabled={loading}
          loading={loading}
        >
          Start Your Loan Application
        </CtaButton>
      </div>

      <img src={OppMobileScreen} alt='OppLoans Mobile' css={phoneImageStyle} />
    </div>
  );
}

export default ClickThroughTopSection;
